import {DiscoverGameGamePlayerResponse} from "libs/apiClient";
import {Link} from "react-router";

export function GamePlayersTable({
	gamePlayersData
}: {
	gamePlayersData: DiscoverGameGamePlayerResponse[]
}) {
	if (gamePlayersData.length === 0) {
		return <div className="empty-sub-table">No player</div>
	}

	gamePlayersData.sort((a, b) => {
		if (a.numberSign === b.numberSign) {
			return 0;
		}

		return (a.numberSign || 0) < (b.numberSign || 0) ? -1 : 1;
	});

	gamePlayersData.sort((a, b) => {
		if (a.isSubstitution === b.isSubstitution) {
			return 0;
		}

		return !a.isSubstitution && b.isSubstitution ? -1 : 1;
	});

    return (
		<table className="discover-table">
			<thead>
				<tr>
					<th>No.</th>
					<th>Name</th>
					<th>Position</th>
				</tr>
			</thead>
			<tbody>
				{gamePlayersData.map((gp: DiscoverGameGamePlayerResponse, index) => (
					<tr key={`row-${index}`} style={{opacity: gp.isSubstitution ? .5 : "initial"}}>
						<td><strong>{gp.numberSign || "-"}</strong></td>
						<td>
							{gp.player?.playerData?.id ? <Link to={`/discover/player-data/${gp.player.playerData.id}`}>
								<strong>{gp.player?.name || "-"}</strong>
							</Link> : (gp.player?.name || "-")}
						</td>
						<td>{gp.position || "-"}</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
